import GWTInjectPoint from 'Application/GWTInjectPoint';
import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { isAppLoadedOnLegacyUrl } from 'utils/navigation';

export default function useGWTPagesSupport() {
  const history = useHistory();
  // Big hack: expose history so that GWT can navigate properly:
  if (!isAppLoadedOnLegacyUrl()) {
    window.XM_HISTORY = history;
  }

  const location = useLocation();
  useEffect(() => {
    if (!isAppLoadedOnLegacyUrl()) {
      window.xmGwtOnPopState?.();
    }
  }, [location]);

  return { GWTInjectPoint };
}
